import fitToast from '../components/toast/toast.vue';
import load from './core/load';
import { IconType } from '../../types/icon';

const toast = load(fitToast);

interface ToastConfig {
	icon?: IconType;
	title?: string;
	duration: number;
	image?: string;
}


function showToast(toastConfig: ToastConfig) {
	toast.show(toastConfig);
}
function hideToast() {
	toast.hide();
}
export { showToast, hideToast }